import { SHOP_MAP } from 'constant/shop';
import { ContractLang, ContractType } from '../utils';
import { LANGUAGE_MAP } from 'constant/language';

const CustomerInfo = ({
  userInfoRenderLineList,
  contractLang,
  memberId,
  isStoreCopy,
}: {
  userInfoRenderLineList: string[];
  contractLang: ContractLang;
  memberId: number;
  isStoreCopy: boolean;
}) => {
  return (
    <div className="border p-px basis-[68%] shrink-0">
      <div className="border p-2">
        {userInfoRenderLineList.map((rawText, index) => {
          let text = rawText || '';

          if (isStoreCopy && index === 0) {
            text = `${text} 、${
              {
                [LANGUAGE_MAP.EN]: 'Customer',
                [LANGUAGE_MAP.JA]: '顧客',
                [LANGUAGE_MAP.ZH_CN]: '顾客',
                [LANGUAGE_MAP.FR]: 'Client',
              }[contractLang]
            } NO.${memberId}`;
          }

          return (
            <div key={index} className="border-b mb-2 h-4">
              {text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const CompanyInfo = ({ storeId }: { storeId: number }) => {
  if (storeId === SHOP_MAP.HONGKONG) {
    return (
      <div className="text-right">
        ASU Company Limited
        <br />
        HONGKONG
        <br />
        G/F, Pacific House, 20B
        <br />
        Queen's Road Central, Hong Kong
        <br />
        Email &nbsp;&nbsp;info.hk@asubrand.jp
        <br />
        TEL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+852 2662 9721
      </div>
    );
  }

  if (storeId === SHOP_MAP.SINGAPORE) {
    return (
      <div className="text-right">
        ASU COMPANY PTE. LTD.
        <br />
        391B ORCHARD ROAD, #23-05, NGEE ANN CITY, SINGAPORE 238874
        <br />
        UEN: 201939838Z
        <br />
        EMAIL: info.sg@asubrand.jp
        <br />
        TEL: +65 6530 3529
      </div>
    );
  }

  if (storeId === SHOP_MAP.GINZA) {
    return (
      <div className="text-right">
        ASU BRAND 株式会社
        <br />
        GINZA XIAOMA
        <br />
        東京都中央区銀座1丁目8-21
        <br />
        第21中央ビル1F・2F
        <br />
        TEL 03-6264-5267
        <br />
        登録番号:T6011101072905
      </div>
    );
  }

  if (storeId === SHOP_MAP.SHANG_HAI) {
    return (
      <div className="text-right">
        上海市黄浦区淮海中路222号607室
        <br />
        XIAOMA 上海
        <br />
        电话&nbsp;&nbsp;+86 153 0162 1883
      </div>
    );
  }

  if (storeId === SHOP_MAP.UMEDA) {
    return (
      <div className="text-right">
        ASU BRAND 株式会社
        <br />
        XIAOMA梅田店
        <br />
        大阪府大阪市北区梅田1丁目8-17
        <br />
        大阪第一生命ビル1階
        <br />
        TEL&nbsp;&nbsp;06-6467-8153
        <br />
        登録番号:T6011101072905
      </div>
    );
  }

  if (storeId === SHOP_MAP.DUBAI) {
    return (
      <div className="text-right">
        ASU Company Limited
        <br />
        DUBAI
        <br />
        Room102，32 Marasi Drive Street
        <br />
        The Binary by Omniyat，Business Bay
        <br />
        Dubai United Arab Emirates
        <br />
        Email &nbsp;&nbsp;dubai@ginzaxiaoma.com
        <br />
        <br />
        TEL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;00971 4 5540680
      </div>
    );
  }

  if (storeId === SHOP_MAP.FRANCE) {
    return (
      <div className="text-right">
        XIAOMA PARIS
        <br />
        PARIS
        <br />
        9 Rue de la Paix, 75002
        <br />
        Email : info.fr@ginzaxiaoma.com
        <br />
        Tél. : +33 0140280349
      </div>
    );
  }

  if (storeId === SHOP_MAP.NEW_YORK) {
    return (
      <div className="text-right">
        XIAOMA NEW YORK
        <br />
        Trump Tower, Suite 1901
        <br />
        725 Fifth Avenue
        <br />
        New York, NY 10022
        <br />
        United States
        <br />
        TEL &nbsp;&nbsp;+1 9177488152
        <br />
        Mon-Sat 10:00-19:00
      </div>
    );
  }

  return null;
};

const CustomerCompanyInfo = ({
  contractType,
  storeId,
  userInfoRenderLineList,
  contractLang,
  memberId,
  isStoreCopy,
}: {
  contractType: ContractType;
  storeId: number;
  userInfoRenderLineList: string[];
  contractLang: ContractLang;
  memberId: number;
  isStoreCopy: boolean;
}) => {
  const isCustomerCopy =
    contractType === 'SELL_CUSTOMER' || contractType === 'RECYCLE_CUSTOMER';
  return (
    <div className="flex items-center mb-4 justify-between shrink-0">
      <CustomerInfo
        userInfoRenderLineList={userInfoRenderLineList}
        contractLang={contractLang}
        memberId={memberId}
        isStoreCopy={isStoreCopy}
      />
      {isCustomerCopy ? <CompanyInfo storeId={storeId} /> : null}
    </div>
  );
};

export default CustomerCompanyInfo;
